const root = (state) => state.store.barometre;

export const getVaguesSelector = (state) => root(state).vagues;
export const getDetailSelector = (state) => root(state).detail;
export const getSyntheseSelector = (state) => root(state).synthese;
export const getHistorySelector = (state) => root(state).history;
export const getActionSelector = (state) => root(state).action;
export const getEmployesSelector = (state) => root(state).employes;
